export default __webpack_public_path__ + "static/media/three-dots-vertical.f2c83354.svg";